import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import requests from 'app/requests/HsCode.requests'
import {
    HsCode,
} from '../HsCode/HsCode.types'

export default function useGetContainerUnitPrice(id: number) {
    return useRequest<HsCode>({
        key: RequestKeys.getHsCode,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}
